import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
function NotFound(props) {
    const { className, showImage = true, subtitleExpression = '', titleExpression = 'tws.not-found.results-not-found', } = props;
    const names = classNames({
        'o-not-found': true,
        [`${className}`]: Boolean(className),
    });
    return (React.createElement("div", { className: names },
        showImage && React.createElement("div", { className: "o-not-found__img u-hide@xsm" }),
        React.createElement("span", { className: "o-not-found__title" }, MessageService.translate(titleExpression)),
        React.createElement("span", { className: "o-not-found__subtitle" }, MessageService.translate(subtitleExpression))));
}
export { NotFound, };
//# sourceMappingURL=not-found.js.map